import {SELECIONAR_EMPRESA} from '../reducers/empresasReducer';

export function selecionarEmpresa (empresa) {
    return {
        type: SELECIONAR_EMPRESA,
        payload: empresa
    }
}
